module.exports = __webpack_public_path__ + "img/googleplay.3f28afcf.svg";